import React from 'react'
import { PLPFiltersTracking } from "@/components/common/Tracking";

function CustomClearRefinements({seoData}) {
  // function to clear filters
  const handleClearRefinements = () => {
    PLPFiltersTracking("Clear all","",false);
    const newUrl = seoData?.search_query ? `${location.pathname}?query=${seoData?.search_query}` : location.pathname;
    window.location.href = newUrl;
  };
  return (
    <button
      className="btn-primary-inverted black" onClick={handleClearRefinements}>
      Clear Filters
    </button>
  )
}
export default CustomClearRefinements